import { render, staticRenderFns } from "./ManageImagePreview.vue?vue&type=template&id=2b65e40a&scoped=true"
import script from "./ManageImagePreview.vue?vue&type=script&lang=js"
export * from "./ManageImagePreview.vue?vue&type=script&lang=js"
import style0 from "./ManageImagePreview.vue?vue&type=style&index=0&id=2b65e40a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b65e40a",
  null
  
)

export default component.exports